<div *ngIf="jobAvailable" class="container" [ngClass]="printActive ? 'return-view-background-print' : 'return-view-background'" style="page-break-inside: avoid">
    <div class="row my-3">
        <div class="col-sm-12 text-center font-weight-bold">
            Schedule 1
        </div>
    </div>
    <div class="row my-3 font-weight-bold">
        <div class="col-sm-12 text-center">
            Particulars of Income from Employment
        </div>
        <div class="col-sm-12 text-center">
            a. This part is applicable for employees receiving salary under government pay scale.
        </div>
    </div>
    <div class="row my-3">
        <div class="col-sm-5">Name of the Taxpayer: {{returnData?.profileData?.assesName}}</div>
        <div class="col-sm-7 text-right">
            TIN:
            <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item }}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
            </span>
        </div>
    </div>

    <div class="my-5 govt-job-table">
        <div class="row bt bb" style="height:50px">
            <div class="col-sm-5 text-center bl br">Particulars</div>
            <div class="col-sm-2 text-center br">Total Amount (Taka)</div>
            <div class="col-sm-3 text-center br">Exempted Amount (Taka)</div>
            <div class="col-sm-2 text-center br">Taxable Amount (Taka)</div>
        </div>
        <div class="row bb">
          <div class="col-sm-5 bl br">1. Basic pay</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_BASIC_PAY?.gross : '') | currencySeparatorBD }}</div>
          <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_BASIC_PAY?.exempted : '') | currencySeparatorBD }}</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_BASIC_PAY?.taxable : '') | currencySeparatorBD }}</div>
      </div>
      <div class="row bb">
          <div class="col-sm-5 bl br">2. Arrear Pay (if not included in taxable income earlier)</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_ARREAR_PAY?.gross : '') | currencySeparatorBD }}</div>
          <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_ARREAR_PAY?.exempted : '' ) | currencySeparatorBD}}</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_ARREAR_PAY?.taxable : '') | currencySeparatorBD }}</div>
      </div>
      <div class="row bb">
          <div class="col-sm-5 bl br">3. Special allowance</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_SPECIAL_PAY?.gross : '') | currencySeparatorBD }}</div>
          <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_SPECIAL_PAY?.exempted : '') | currencySeparatorBD }}</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_SPECIAL_PAY?.taxable : '') | currencySeparatorBD}}</div>
      </div>
      <div class="row bb">
          <div class="col-sm-5 bl br">4. House Rent allowance</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_HOUSE_RENT_ALW?.gross : '') | currencySeparatorBD }}</div>
          <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_HOUSE_RENT_ALW?.exempted : '') | currencySeparatorBD }}</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_HOUSE_RENT_ALW?.taxable : '') | currencySeparatorBD }}</div>
      </div>
      <div class="row bb">
          <div class="col-sm-5 bl br">5. Medical allowance</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_MEDICAL_ALW?.gross : '') | currencySeparatorBD }}</div>
          <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_MEDICAL_ALW?.exempted : '') | currencySeparatorBD }}</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_MEDICAL_ALW?.taxable : '') | currencySeparatorBD }}</div>
      </div>
      <div class="row bb">
          <div class="col-sm-5 bl br">6. Conveyance allowance</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_CONVEYANCE_ALW?.gross : '') | currencySeparatorBD }}</div>
          <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_CONVEYANCE_ALW?.exempted : '') | currencySeparatorBD }}</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_CONVEYANCE_ALW?.taxable : '') | currencySeparatorBD }}</div>
      </div>
      <div class="row bb">
          <div class="col-sm-5 bl br">7. Festival allowance</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_FESTIVAL_BONUS?.gross : '') | currencySeparatorBD }} </div>
          <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_FESTIVAL_BONUS?.exempted : '') | currencySeparatorBD }}</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_FESTIVAL_BONUS?.taxable : '') | currencySeparatorBD }}</div>
      </div>
      <div class="row bb">
          <div class="col-sm-5 bl br">8. Support Staff allowance</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.ALLOWANCE_SUPPORT_STAFF?.gross : '') | currencySeparatorBD }}</div>
          <div class="col-sm-3 br">{{(govtSum ? govtSalary?.ALLOWANCE_SUPPORT_STAFF?.exempted : '') | currencySeparatorBD }}</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.ALLOWANCE_SUPPORT_STAFF?.taxable : '') | currencySeparatorBD }}</div>
      </div>
      <div class="row bb">
          <div class="col-sm-5 bl br">9. Leave allowance</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_REST_RECREATION_ALW?.gross : '') | currencySeparatorBD }}</div>
          <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_REST_RECREATION_ALW?.exempted : '') | currencySeparatorBD }}</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_REST_RECREATION_ALW?.taxable : '') | currencySeparatorBD }}</div>
      </div>
      <div class="row bb">
          <div class="col-sm-5 bl br">10. Honorarium / Reward</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_HONORARIUM_REWARD_FEE?.gross : '') | currencySeparatorBD }}</div>
          <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_HONORARIUM_REWARD_FEE?.exempted : '') | currencySeparatorBD }}</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_HONORARIUM_REWARD_FEE?.taxable : '') | currencySeparatorBD }}</div>
      </div>
      <div class="row bb">
          <div class="col-sm-5 bl br">11. Overtime allowances</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_OVERTIME_ALW?.gross : '') | currencySeparatorBD }}</div>
          <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_OVERTIME_ALW?.exempted : '') | currencySeparatorBD }}</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_OVERTIME_ALW?.taxable : '') | currencySeparatorBD }}</div>
      </div>
      <div class="row bb">
          <div class="col-sm-5 bl br">12. Bangla Noboborsho allowances</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_BANGLA_NEW_YEAR_ALW?.gross : '') | currencySeparatorBD }}</div>
          <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_BANGLA_NEW_YEAR_ALW?.exempted : '') | currencySeparatorBD }}</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_BANGLA_NEW_YEAR_ALW?.taxable : '') | currencySeparatorBD }}</div>
      </div>
      <div class="row bb">
          <div class="col-sm-5 bl br">13. Interest accrued on Provident Fund</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_GPF_INTEREST?.gross : '') | currencySeparatorBD }}</div>
          <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_GPF_INTEREST?.exempted : '') | currencySeparatorBD }}</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_GPF_INTEREST?.taxable : '') | currencySeparatorBD }}</div>
      </div>
      <div class="row bb">
          <div class="col-sm-5 bl br">14. Lump Grant</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_LUMPGRANT_LEAVE_ENCASH?.gross : '') | currencySeparatorBD }}</div>
          <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_LUMPGRANT_LEAVE_ENCASH?.exempted : '') | currencySeparatorBD }}</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_LUMPGRANT_LEAVE_ENCASH?.taxable : '') | currencySeparatorBD }}</div>
      </div>
      <div class="row bb">
          <div class="col-sm-5 bl br">15. Gratuity</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_GRATUITY?.gross : '') | currencySeparatorBD }}</div>
          <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_GRATUITY?.exempted : '') | currencySeparatorBD }}</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_GRATUITY?.taxable  : '') | currencySeparatorBD}}</div>
      </div>
      <div class="row bb">
          <div class="col-sm-5 bl br">16. Others, if any (provide detail)</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_OTHER?.gross : '') | currencySeparatorBD }}</div>
          <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_OTHER?.exempted : '') | currencySeparatorBD }}</div>
          <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_OTHER?.taxable : '') | currencySeparatorBD }}</div>
      </div>

        <div class="row bb">
            <div class="col-sm-5 bl br">17. Total</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_SUM?.gross : '') | currencySeparatorBD }}</div>
            <div class="col-sm-3 br">{{(govtSum ? govtSalary?.IS_SUM?.exempted : '') | currencySeparatorBD }}</div>
            <div class="col-sm-2 br">{{(govtSum ? govtSalary?.IS_SUM?.taxable : '') | currencySeparatorBD }}</div>
        </div>
    </div>


    <!-- non govt employee -->

    <div style="page-break-inside: avoid;">
        <div class="row my-3">
            <div class="col-sm-12 text-center font-weight-bold">
              b. This part is applicable for employees other than employees receiving salary under government pay scale.
            </div>
        </div>
        <div class="row my-3">
          <div class="col-sm-5">Name of the Taxpayer: {{returnData?.profileData?.assesName}}</div>
          <div class="col-sm-7 text-right">
              TIN:
              <span class="ml-3" style="white-space: nowrap;">
                  <input value="{{item }}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
              </span>
          </div>
        </div>
        <div class="my-3">
            <div class="row bt bb">
                <div class="col-sm-8 text-center bl br pt-1 pb-3">Particulars</div>
                <div class="col-sm-2 text-center br pt-1 pb-3">Income (Taka)</div>
                <div class="col-sm-2 text-center br pt-1 pb-3">Income (Taka)</div>
            </div>
            <div class="row">
                <div class="col-sm-12 nongovt-job-table">
                    <div class="row bb">
                        <div class="col-sm-8 bl br">1. Basic pay</div>
                        <div class="col-sm-2 br">{{(nongovtSum ? nongovtSalary?.IS_BASIC_PAY?.gross : '') | currencySeparatorBD }}</div>
                        <div class="col-sm-2 br"></div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">2. Allowances</div>
                        <div class="col-sm-2 br">{{(nongovtSum ? nongovtSalary?.IS_ALLOWANCES.gross : '') | currencySeparatorBD }}</div>
                        <div class="col-sm-2 br"></div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">3. Advance / Arrear Salary</div>
                        <div class="col-sm-2 br">{{(nongovtSum ? nongovtSalary?.IS_ARREAR_PAY?.gross : '') | currencySeparatorBD }}</div>
                        <div class="col-sm-2 br"></div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">4. Gratuity, Annuity, Pension or similar benefit</div>
                        <div class="col-sm-2 br">{{(nongovtSum ? nongovtSalary?.IS_GRATUITY_AND_IS_PENSION?.gross : '') | currencySeparatorBD }}</div>
                        <div class="col-sm-2 br"></div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">5. Perquisites</div>
                        <div class="col-sm-2 br"></div>
                        <div class="col-sm-2 br"></div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">6. Receipt in lieu of or in addition to Salary or Wages</div>
                        <div class="col-sm-2 br"></div>
                        <div class="col-sm-2 br"></div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">7. Income from Employee’s Share Scheme</div>
                        <div class="col-sm-2 br">{{(nongovtSum ? nongovtSalary?.IS_EMP_SHARE_RECEIVED_AND_SELL?.gross : '') | currencySeparatorBD }}</div>
                        <div class="col-sm-2 br"></div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">8. Accommodation Facility</div>
                        <div class="col-sm-2 br">{{(nongovtSum ? nongovtSalary?.IS_EMP_ACCOMMODATION_FACILITY?.gross : '') | currencySeparatorBD }}</div>
                        <div class="col-sm-2 br"></div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">9. Transport Facility</div>
                        <div class="col-sm-2 br">{{(nongovtSum ? nongovtSalary?.IS_MOTOR_CAR_FACILITY?.gross : '') | currencySeparatorBD }}</div>
                        <div class="col-sm-2 br"></div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">10. Any other Facility provided by Employer</div>
                        <div class="col-sm-2 br">{{(nongovtSum ? nongovtSalary?.IS_OTHER_NON_CASH_BENEFITS?.gross : '') | currencySeparatorBD }}</div>
                        <div class="col-sm-2 br"></div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">11. Employer’s Contribution to Recognized Provident Fund</div>
                        <div class="col-sm-2 br">{{(nongovtSum ? nongovtSalary?.IS_EMP_CONTRIBUTION_RPF?.gross : '') | currencySeparatorBD }}</div>
                        <div class="col-sm-2 br"></div>
                    </div>
                    <div class="row bb">
                        <div class="col-sm-8 bl br">12. Others, if any (provide detail)</div>
                        <div class="col-sm-2 br">{{(nongovtSum ? nongovtSalary?.IS_OTHER?.gross : '') | currencySeparatorBD }}</div>
                        <div class="col-sm-2 br"></div>
                    </div>
                </div>
                <!-- <div class="col-sm-3 bb br text-center py-2">
                    {{(nongovtSum ? nongovtSalary?.IS_SUM?.gross : '') | currencySeparatorBD }}
                </div> -->
            </div>
            <div class="row bb">
                <div class="col-sm-8 bl br py-2">13. Total Salary Received (aggregate of 1 to 12)</div>
                <div class="col-sm-2 br py-2"></div>
                <div class="col-sm-2 br py-2 text-right">{{(nongovtSum ? nongovtSalary?.IS_SUM?.gross : '') | currencySeparatorBD }}</div>
            </div>
            <div class="row bb">
                <div class="col-sm-8 bl br py-2">14. Exempted Amount (as per Part 1 of 6th Schedule)</div>
                <div class="col-sm-2 br py-2"></div>
                <div class="col-sm-2 br py-2 text-right">{{(nongovtSum ? nongovtSalary?.IS_SUM?.exempted : '') | currencySeparatorBD }}</div>
            </div>
            <div class="row bb">
                <div class="col-sm-8 bl br py-2">15. Total Income from Salary (13 – 14)</div>
                <div class="col-sm-2 br py-2"></div>
                <div class="col-sm-2 br py-2 text-right">{{(nongovtSum ? nongovtSalary?.IS_SUM?.taxable : '') | currencySeparatorBD }}</div>
            </div>
        </div>
    </div>
</div>
